import truncate from 'lodash-es/truncate';
import {
    FORUM_POST_ADMINCLUB_MENU,
    SEO_TITLE_WIKI_article,
    WIKI_ARTICLE_ADD_NEW,
    WIKI_ARTICLE_EDIT,
    WIKI_REPORT_MISTAKE_IN_ARTICLE,
    WIKI_WRITE_EXPERIENCE,
} from 'mk/autogenerated/translations/ArticlePage.cfd93c89561d4bfce59167f551d2fd02'
import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { about_help_form_url, adminclub_wiki_article_url } from 'mk/urls/functions';
import { DateRange1, KeywordFilterType } from 'mk2/apps/dash/containers/SeoPerformance/FilterForm';
import * as dashUrls from 'mk2/apps/dash/urls';
import { FeedbackFormData } from 'mk2/apps/wiki/components/FeedbackForm';
import Article from 'mk2/apps/wiki/containers/Article/Article';
import {
    articleFetchTrigger,
    feedbackSubmit,
    wikiArticleAddExperience,
} from 'mk2/apps/wiki/containers/Article/Article.actions';
import { WIKI_MENU_MORE } from 'mk2/apps/wiki/containers/Article/Article.constants';
import { getWikiArticleState } from 'mk2/apps/wiki/containers/Article/Article.selectors';
import { WIKI_EXPERIENCE_MENU_MORE } from 'mk2/apps/wiki/helpers';
import { ArticleEntity, ArticleSchema } from 'mk2/apps/wiki/schemas';
import { articleWiki, articleWikiOG, breadcrumbsWiki } from 'mk2/apps/wiki/structuredData';
import * as urls from 'mk2/apps/wiki/urls';
import { poormanPlaintext, wikiArticleUrl } from 'mk2/apps/wiki/utils';
import Btn, { BtnType } from 'mk2/components/Btn';
import MenuItem from 'mk2/components/menu/MenuItem';
import { AppName } from 'mk2/containers/Application/Application';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import Page, { BrandingProps, HalfpageProps } from 'mk2/pages/Page';
import {
    AppState,
    getRequestBaseUrl,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
} from 'mk2/reducers';
import { LoadingState } from 'mk2/reducers/loadingState';
import { MenuSelection, UserEntity } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { interpolate } from 'mk2/services/i18n';
import { Store } from 'mk2/store/configureStore';
import * as React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';

interface OwnProps {
}

interface StateProps {
    article: ArticleEntity;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    mobile: boolean;
    loadingState: LoadingState;
    feedbackSubmitted: boolean;
    baseUrl: string;
    errorMessage: string;
    experienceIdRef: string;
}

interface DispatchProps {
    onLoad(articleSlug: string, categorySlug: string);
    onToggleMenuMore(id: number);
    onWikiToggleMenuMore();
    onSaveFeedBack(articleSlug: string, categorySlug: string, values: FeedbackFormData);
    onAddExperience();
}

type RouteProps = RouteComponentProps<{
    articleSlug: string;
    categorySlug?: string;
}>;
export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ArticlePage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const experienceIdRef = ownProps.location.hash;
            const articleSlug = ownProps.match.params.articleSlug;
            const categorySlug = ownProps.match.params.categorySlug;
            const articleState = getWikiArticleState(state, categorySlug, articleSlug);
            const article: ArticleEntity = getDenormalizedEntity<ArticleEntity>(state, ArticleSchema, articleState.articleId);
            return {
                article,
                experienceIdRef,
                mobile: getRequestDeviceMobile(state),
                requestUser: getRequestUser(state),
                requestUserPermissions: getRequestPermissions(state),
                loadingState: articleState.loadingState,
                feedbackSubmitted: articleState.feedbackSubmitted,
                baseUrl: getRequestBaseUrl(state),
                errorMessage: articleState.errorMessage,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onToggleMenuMore: (id: number) => menuToggle(WIKI_EXPERIENCE_MENU_MORE(id)),
            onLoad: articleFetchTrigger,
            onWikiToggleMenuMore: () => menuToggle(WIKI_MENU_MORE),
            onSaveFeedBack: feedbackSubmit,
            onAddExperience: wikiArticleAddExperience,
        };
    }

    public getMetaTitle(props: Props): string {
        const { article } = props;
        if (article) {
            // custom napisany SEO title, alebo to iste ako nadpis clanku
            return article.seoTitle || interpolate(SEO_TITLE_WIKI_article, { article: article.title });
        } else {
            return null;
        }
    }

    public getMetaDescription(props: Props): string {
        const { article } = props;
        if (article) {
            // custom napisany SEO description, alebo to iste ako prvy odstavec clanku
            // FIXME caka na json-markdown aby sme ako description poslali iba plaintext z prveho odstavca
            return article.seoDescription || truncate(poormanPlaintext(article.text), {length: 300, separator: ' ' });
        } else {
            // pouzi defaultny description v Page
            return null;
        }
    }

    public getStructuredData(props: Props): object[] {
        const { article, baseUrl } = props;
        if (article) {
            return [
                breadcrumbsWiki(baseUrl, article),
                articleWiki(baseUrl, article),
            ];
        }
    }

    public getOpenGraphData(props: Props, baseUrl: string, currentUrl: string): {[key: string]: string} {
        const { article } = props;
        if (article) {
            return {
                ...super.getOpenGraphData(props, baseUrl, currentUrl),
                ...articleWikiOG(baseUrl, article),
            };
        }
    }

    public render(props: Props): false | JSX.Element {
        return (
            <div>
                <Article {...props} />
            </div>
        );
    }

    public hasHeaderBackButton(props: Props): boolean {
        // po diskusi v SEO agenture: je lepsie ked wiki clanok stale zobrazuje
        // hamburger menu. Najcastejsi usecase je, ze user landne na clanok z Google
        // preklikne sa mozno este na jeden, dva dalsie wiki clanky a potom chce odist
        //
        // Mal by preto hlavne vidiet ze je na MK a dostat sa rychlo na ine sekcie stranky.
        // Back button ho nema kam rozumne vracat, lebo medzi wiki clankami nie je silna
        // parent-child hierarchia.
        return false;
    }

    public getBrandingProps(props: Props): BrandingProps {
        const { article } = props;
        if (article && !article.disabledAds) {
            return {
                zone: 'Wiki - Branding',
            };
        }
        return null;
    }

    public getHalfpageProps(props: Props): HalfpageProps {
        const { article } = props;
        if (article && !article.disabledAds) {
            return {
                zone: 'Wiki - Halfpage Sticky (Desktop)',
            };
        }
        return null;
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const {
            requestUser, requestUserPermissions, article, onWikiToggleMenuMore, baseUrl, onAddExperience,
        } = props;

        const isDeleted = article && article.deletedAt;
        if (isDeleted) {
            return null;
        }

        const isAuthor = article && isAuthenticatedAs(requestUser, article.author);
        const isAdmin = requestUserPermissions.indexOf('wiki.can_edit_wiki') >= 0;

        let menu;
        let addBtn;

        if (article) {
            addBtn = article.experiencesAllowed ? (
                <Btn
                    key="addBtn"
                    type={BtnType.Blue}
                    icon="fa-pencil"
                    label={WIKI_WRITE_EXPERIENCE}
                    onClick={isAuthenticated(requestUser) ? null : onAddExperience}
                    link={isAuthenticated(requestUser) ? url(urls.wikiAddExperience, {
                        articleSlug: article.slug,
                        categorySlug: article.category.slug,
                    }) : null}
                />
            ) : null;
        }
        const hasCreate = article && isAdmin;
        const hasEdit = article && isAdmin;
        const hasAdminclub = article && isAdmin;
        const hasSeoStats = article && requestUserPermissions.indexOf('dash.can_manage_seo') >= 0;
        menu = (
            <Menu
                key="menu"
                menuId={WIKI_MENU_MORE}
                trigger={
                    <Btn
                        type={BtnType.BlueOutline}
                        icon="fa-cog fa-lg"
                        onClick={onWikiToggleMenuMore}
                    />
                }
            >
                {hasCreate && (
                    <MenuItem
                        label={WIKI_ARTICLE_ADD_NEW}
                        icon="fa-plus-circle"
                        link={urls.wikiArticleCreate}
                        isAdminUI={!isAuthor && isAdmin}
                    />
                )}

                {article &&
                    <MenuItem
                        label={WIKI_REPORT_MISTAKE_IN_ARTICLE}
                        icon="fa-exclamation-triangle"
                        link={about_help_form_url({
                            faq: 'wiki-suggestion',
                            next: baseUrl + wikiArticleUrl(article),
                            arg: baseUrl + wikiArticleUrl(article),
                        })}
                        isAdminUI={!isAuthor && isAdmin}
                        asAnchor
                    />
                }

                {hasEdit && (
                    <MenuItem
                        label={WIKI_ARTICLE_EDIT}
                        icon="fa-pencil"
                        link={url(urls.wikiArticleEdit, { articleId: article.id })}
                        isAdminUI={!isAuthor && isAdmin}
                    />
                )}

                {hasAdminclub && (
                    <MenuItem
                        label={FORUM_POST_ADMINCLUB_MENU}
                        icon="fa-life-ring"
                        link={adminclub_wiki_article_url(article.id)}
                        asAnchor
                        isAdminUI
                    />
                )}

                {hasSeoStats && (
                    <MenuItem
                        label="SEO traffic"
                        icon="fa-line-chart"
                        link={
                            url(dashUrls.dashSeoPerformace, {}, {
                                range1: DateRange1[DateRange1.Past12Weeks],
                                urls: `pageid:wiki-article-${article.id}`,
                                keywords: KeywordFilterType[KeywordFilterType.NonBranded],
                            })}
                        asAnchor
                        linkTarget="_blank"
                        isAdminUI
                    />
                )}
            </Menu>
        );

        return [menu, '\u00A0\u00A0', addBtn];
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: props.article ? props.article.slug : null,
        };
    }

    public registerInStore(store?: Store<AppState>) {
        return this.loadAndRegisterReducerAndSaga(
            'containers.wiki.article',
            import('mk2/apps/wiki/containers/Article/Article.reducers' /* webpackChunkName: "wiki.Article" */),
            import('mk2/apps/wiki/containers/Article/Article.sagas' /* webpackChunkName: "wiki.Article" */),
            store,
        );
    }

}
